import { useQuery } from "@tanstack/react-query"
import { ApprovedCircled } from "../../../icons/approvedCircled"
import { CircledLoading } from "../../../icons/circledLoading"
import { ContractLoading } from "../../../icons/contractLoading"
import { DocumentLoading } from "../../../icons/documentLoading"
import { HourglassIcon } from "../../../icons/hourglassIcon"
import { Button } from "../../ui/Button"
import { useParams } from "react-router-dom"
import { getPreferenceFormFn } from "../../../transactions/orders/orders"
import { useEffect, useState } from "react"
import { TextField } from "../../ui/TextField"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/Dropdown"
import { ToggleButton } from "../../ui/Toggle/ToggleButton"
import { queryClient } from "../../../utils/queryClient"
import { mapStepToMessage } from "../../../utils/helper"

export const DocumentationThird = ({ currentStep, state, onStepCompleted }) => {
    const { orderId } = useParams();
    const [fields, setFields] = useState();
    const [values, setValues]  = useState()

    useQuery({
        queryKey: [orderId,'preferenceform'],
        queryFn: () => getPreferenceFormFn(orderId),
        onSuccess: (data) => {
            setFields(data.data);
          },
        staleTime: Infinity,
        cacheTime: Infinity,
        enabled: state.substatus === 0
    });

    useEffect(() => {
        queryClient.invalidateQueries({ queryKey: [orderId,'preferenceform'] });
        if (fields) {
            let initValues = {}
            Object.keys(fields).forEach(key => {
                initValues[key] = fields[key].type === 'dropdown' || fields[key].type === 'radio' ? 0 : '' 
            })
            setValues(initValues);
       } 
    },[fields])
    
    return(
        <>
            {state && <>
                <div className="flex border-b pb-2  border-b-[#A5A5A5] justify-between">
                    <div className="flex gap-2 pl-4 items-center">
                        <HourglassIcon/>
                        <h4>Διαδικασία Έγκρισης</h4>
                    </div>
                    <Button disabled={state.substatus !== 0} onClick={() => { onStepCompleted(values) }} className={'max-lg:hidden disabled:bg-[#A5A5A5] bg-[#D4002A] px-5 py-2.5 rounded-full text-white text-sm font-[600]'}>Επόμενο</Button>
                </div>
                <div className="lg:py-16 py-4 px-2 lg:px-16 flex  flex-col gap-10 lg:container lg:mx-auto">
                    <div className="flex gap-2 justify-center">
                        <div className="items-center flex flex-col gap-2 text-center">
                            {currentStep === 5 ? <ApprovedCircled className={'max-lg:w-[40px]'}/>: <CircledLoading className={'stroke-[#A5A5A5] max-lg:w-[40px]'}/> }   
                            <p className=" w-8/12 text-[#6A6A6A] text-body">Έγκριση Φόρμας Νέου Πελάτη</p>
                        </div>
                        <div className="w-[25%] h-[2px] bg-[#D9D9D9] mt-6"/>
                        <div className="items-center flex flex-col gap-2 text-center">
                        {currentStep === 5 ? <ApprovedCircled className={'max-lg:w-[40px]'}/>: <DocumentLoading className={'max-lg:w-[40px]'}/>}   
                            <p className=" w-8/12 text-[#6A6A6A] text-body">Έγκριση Εγγράφων</p>
                        </div>
                        <div className="w-[25%] h-[2px] bg-[#D9D9D9] mt-6"/>
                        <div className="items-center flex flex-col gap-2 text-center">
                        {state.substatus === 0 ? <ApprovedCircled className={'max-lg:w-[40px]'}/>: <ContractLoading className={'max-lg:w-[40px]'}/>}   
                            <p className=" w-8/12 text-[#6A6A6A] text-body">Δημιουργία Συμβολαίων</p>
                        </div>
                    </div>
                    <div className="w-full flex p-8 flex-col gap-4 border border-[#A5A5A5] rounded-[12px] max-lg:bg-[#F5F5F7]">
                        <h4>Τελευταία Ενημέρωση</h4>
                        <p className="text-body">{mapStepToMessage(state.step, state.substatus) ?? state.message}</p>
                    </div>
                    {state.substatus === 0 && 
                        <div className="w-ful bg-white rounded-[12px] lg:p-8 p-4 flex flex-col gap-4">
                            <h6>Συμπληρωματικές επιλογές (προαιρετικά)</h6>
                            {fields && values && Object.entries(fields).map(([key,item]) => {
                                if (item.type === 'radio') {
                                    return (
                                        <div className="flex gap-2 items-center">
                                            <ToggleButton checked={values[key]} onCheckedChange={(value) => {
                                                setValues({ ...values, [key]:value ? 1 :0 })
                                            }} />
                                            <p>Pre-Delivery: προσωρινό αυτοκίνητο σε περίπτωση παραγγελίας μη ετοιμοπαράδου αυτοκινήτου.</p>
                                        </div>
                                    )
                                }
                                else if (item.type === 'dropdown') {
                                return (
                                    <div key={item} className="flex flex-col gap-1 lg:w-4/12">
                                        <p className="text-label text-[#C1C1C1]">Επιλογή πινακίδας</p>
                                        <Select defaultValue={0} onValueChange={(value)=>{setValues({ ...values, [key]:value })}}>
                                            <SelectTrigger>
                                                <SelectValue/>
                                            </SelectTrigger>
                                            <SelectContent>
                                                {
                                                   Object.keys(item.options).map((key) =>
                                                       <SelectItem key={key} value={item.options[key]}>{key}</SelectItem>
                                                )}
                                            </SelectContent>
                                        </Select>
                                    </div>
                                )} else {
                                     return <TextField  key={item} value={values[key]} type={item.type} label={item.label} className={'w-full'} onChange={(e) => setValues({ ...values, [key]:e.target.value })}/>
                                }
                            })}
                        </div>
                    }
                </div>
                 <Button disabled={state.substatus !== 0} onClick={() => { onStepCompleted(values) }} className={'lg:hidden disabled:bg-[#A5A5A5] bg-[#D4002A] w-full py-2.5 rounded-[6px] text-white text-sm font-[600] mt-10'}>Επόμενο</Button>    
            </>
            }
    </>
    )
}